export enum TableActionsENUM {
  EDIT,
  DELETE,
  SELECT,
}
